var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 19.7318C6.13301 19.7318 2.58301 16.1818 2.58301 11.8151C2.58301 7.44844 6.13301 3.89844 10.4997 3.89844C14.8663 3.89844 18.4163 7.44844 18.4163 11.8151C18.4163 16.1818 14.8663 19.7318 10.4997 19.7318ZM10.4997 5.14844C6.82467 5.14844 3.83301 8.1401 3.83301 11.8151C3.83301 15.4901 6.82467 18.4818 10.4997 18.4818C14.1747 18.4818 17.1663 15.4901 17.1663 11.8151C17.1663 8.1401 14.1747 5.14844 10.4997 5.14844Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 6.18945C9.47011 6.18945 8.46186 6.48288 7.59308 7.03535C6.72429 7.58782 6.03095 8.37645 5.59429 9.30883C5.15764 10.2412 4.99576 11.2787 5.12761 12.2998C5.25947 13.3209 5.6796 14.2833 6.33879 15.0742C6.99797 15.865 7.86891 16.4517 8.84954 16.7653C9.83017 17.079 10.8799 17.1066 11.8757 16.8451C12.8715 16.5836 13.7721 16.0436 14.472 15.2886C15.172 14.5335 15.6422 13.5947 15.8277 12.5819L10.4997 11.6061V6.18945Z",
    fill: "#D95353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.06445H8C7.65833 3.06445 7.375 2.78112 7.375 2.43945C7.375 2.09779 7.65833 1.81445 8 1.81445H13C13.3417 1.81445 13.625 2.09779 13.625 2.43945C13.625 2.78112 13.3417 3.06445 13 3.06445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDark);
export default __webpack_public_path__ + "static/media/timer-dark.f3ec109d4f43a2a644ac32b9ee81c367.svg";
export { ForwardRef as ReactComponent };